import { SharedProps } from '@/types'
import { Head, router, usePage } from '@inertiajs/react'
import { Button, Paper, Stack, Text, TextInput, Title } from '@mantine/core'
import { IconUser } from '@tabler/icons-react'
import { FormEvent, useEffect, useState } from 'react'

export default function NewSessionPage() {
  const [email, setEmail] = useState('')
  const [isPending, setIsPending] = useState(false)
  const { props } = usePage<SharedProps>()
  const user = props.current_user

  useEffect(() => {
    if (user) router.visit('/')
  }, [user])

  if (user) throw new Error('User is already logged in')

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    setIsPending(true)
    router.post('/connection_code', { email }, { onFinish: () => setIsPending(false) })
  }

  return (
    <>
      <Head title="Se connecter | Seamflow" />
      <div
        style={{
          padding: 'var(--mantine-spacing-xl)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '50vh',
        }}
      >
        <Stack align="center" gap="lg" style={{ width: '100%', maxWidth: '500px' }}>
          <Title order={2} className="flex items-center gap-2">
            <IconUser size={28} />
            Connexion
          </Title>

          <Paper shadow="sm" p="xl" radius="md" withBorder style={{ width: '100%' }}>
            <Stack gap="md">
              <Text c="dimmed" ta="center">
                Rentrez votre email pour recevoir un code de connexion.
              </Text>

              <form onSubmit={handleSubmit}>
                <TextInput
                  aria-label="Email"
                  placeholder="nom@exemple.com"
                  type="email"
                  name="email"
                  autoComplete="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  disabled={isPending}
                  radius="md"
                />
                <Button fullWidth mt="md" radius="md" loading={isPending} type="submit">
                  {isPending ? 'Envoi en cours...' : 'Recevoir le code'}
                </Button>
              </form>
            </Stack>
          </Paper>
        </Stack>
      </div>
    </>
  )
}
